module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('footer', {
    staticClass: "container-fluid"
  }, [_c('div', {
    staticClass: "container"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('ul', [_c('li', [_c('router-link', {
    attrs: {
      "to": {
        name: 'home'
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('navigation.home')))])], 1), _vm._v(" "), _c('li', [_c('router-link', {
    attrs: {
      "to": {
        name: 'about'
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('navigation.about')))])], 1), _vm._v(" "), _c('li', [_c('router-link', {
    attrs: {
      "to": {
        name: 'key_articles'
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('navigation.key_articles')))])], 1), _vm._v(" "), _c('li', [_c('router-link', {
    attrs: {
      "to": {
        name: 'blog'
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('navigation.blog')))])], 1), _vm._v(" "), _c('li', [_c('router-link', {
    attrs: {
      "to": {
        name: 'video'
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('navigation.video')))])], 1), _vm._v(" "), _c('li', [_c('router-link', {
    attrs: {
      "to": {
        name: 'infographics'
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('navigation.infographics')))])], 1), _vm._v(" "), _c('li', [_c('router-link', {
    attrs: {
      "to": {
        name: 'contact'
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('navigation.contact')))])], 1)])]), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('center', [_c('p', [_vm._v("Copyright " + _vm._s(_vm.year) + " MONS")])])], 1)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row"
  }, [_c('img', {
    staticClass: "col-md-6 offset-md-3",
    attrs: {
      "src": "/static/logo.svg",
      "alt": "MONS",
      "height": "50"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "social-media"
  }, [_c('a', {
    attrs: {
      "href": "https://www.facebook.com/monitoring.mons/",
      "target": "_blank"
    }
  }, [_c('i', {
    staticClass: "fa fa-facebook-official",
    attrs: {
      "aria-hidden": "true"
    }
  })]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "https://twitter.com/monitoring_MONS",
      "target": "_blank"
    }
  }, [_c('i', {
    staticClass: "fa fa-twitter-square",
    attrs: {
      "aria-hidden": "true"
    }
  })])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-1572e0ad"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/ui/Footer.vue
// module id = 499
// module chunks = 1